export const EDIT_LOGIN = 'login/EDIT_LOGIN'
export const UPDATE_ERROR_MESSAGE = 'login/UPDATE_ERROR_MESSAGE'
export const UPDATE_SHOW_LOADING = 'login/UPDATE_SHOW_LOADING'
export const UPDATE_MEMBER_REDEEM = 'login/UPDATE_MEMBER_REDEEM'
export const UPDATE_MEMBER_ID = 'login/UPDATE_MEMBER_ID'

export const UPDATE_NAME = 'profile/UPDATE_NAME';